import { render, staticRenderFns } from "./TrainingRequestsList.vue?vue&type=template&id=abf1b36a&"
import script from "./TrainingRequestsList.vue?vue&type=script&lang=js&"
export * from "./TrainingRequestsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports